import {request} from '@/helpers/apiClient'
import {POINT_MULTIPLIER_CONFIG} from '@/utils/constants/apiConfig/pointMutliplierConfig'

export const getPointMultiplier = async (queryParams, body) => {
  return request(POINT_MULTIPLIER_CONFIG.POINT_MULTIPLIER(queryParams), {data: body})
}

export const postPointMultiplierDraft = async req_param => {
  return request(POINT_MULTIPLIER_CONFIG.POINT_MULTIPLIER_DRAFT, req_param)
}

export const postPointMultiplierPublish = async req_param => {
  return request(POINT_MULTIPLIER_CONFIG.POINT_MULTIPLIER_PUBLISH, req_param)
}

export const getPointMultiplierRulesCriteria = queryParams =>
  request(POINT_MULTIPLIER_CONFIG.RULES_CRITERIA_DROPDOWN_LIST, '', queryParams)

export const getPointMultiplierSegment = queryParams =>
  request(POINT_MULTIPLIER_CONFIG.SEGMENT_DROPDOWN_LIST, '', queryParams)

export const getPointMultiplierCategory = queryParams =>
  request(POINT_MULTIPLIER_CONFIG.CATEGORY_DROPDOWN_LIST, '', queryParams)

export const getPointMultiplierOrderChannel = queryParams =>
  request(POINT_MULTIPLIER_CONFIG.ORDER_CHANNEL_DROPDOWN_LIST, '', queryParams)

export const savePointMultiplier = queryParams =>
  request(POINT_MULTIPLIER_CONFIG.POINT_MULTIPLIER, {data: queryParams?.data}, '')

export const getPointMultiplierDetails =async (queryParams) =>{
return await request(POINT_MULTIPLIER_CONFIG.GET_POINT_MULTIPLIER, '', queryParams)
}

export const getPointMultiplierCsvFile = body =>
  request(POINT_MULTIPLIER_CONFIG.POINT_MULTIPLIER_CSV_DOWNLOAD, {data: body})

export const getPointMultiplierProductsCsvFile = id =>
  request(POINT_MULTIPLIER_CONFIG.POINT_MULTIPLIER_PRODUCTS_CSV_DOWNLOAD(id))

export const updatePointMultiplierDraft = async req_param => {
  return request(POINT_MULTIPLIER_CONFIG.UPDATE_POINT_MULTIPLIER_DRAFT, req_param)
}
